export const LICENSE_FEATURES = {
  "analytics.view": {
    title: "Estadísticas avanzadas",
    description: "Consulta tendencias, comparativas y métricas detalladas de equipos y jugadores.",
    plans: ["Coach Web", "Analyst Web", "Club Start"],
    benefits: ["Métricas completas", "Comparativas avanzadas", "Histórico deportivo"],
  },
  "reports.view": {
    title: "Informe completo de partido",
    description: "Desbloquea todas las secciones del informe y el análisis detallado del rival.",
    plans: ["Coach Web", "Analyst Web", "Club Start"],
    benefits: ["Forma reciente", "Plantilla y jugadores clave", "Comparativa táctica"],
  },
  "reports.export": {
    title: "Exportación profesional",
    description: "Genera el informe completo en PowerPoint para compartirlo con tu staff.",
    plans: ["Coach Web", "Analyst Web", "Club Start"],
    benefits: ["Presentación lista para reunión", "Datos completos", "Formato profesional"],
  },
  "scouting.view": {
    title: "Scouting",
    description: "Centraliza jugadores seguidos, partidos observados y tu agenda de scouting.",
    plans: ["Analyst Web", "Club Pro"],
    benefits: ["Seguimiento de jugadores", "Agenda personal", "Notas y observaciones"],
  },
  "scouting.manage": {
    title: "Seguimiento de jugadores",
    description: "Guarda jugadores de interés y centraliza su seguimiento en tu área de scouting.",
    plans: ["Analyst Web", "Club Pro"],
    benefits: ["Lista personal de jugadores", "Notas y observaciones", "Seguimiento centralizado"],
  },
  "planning.manage": {
    title: "Planificación",
    description: "Organiza entrenamientos, partidos y planes semanales para tus equipos asignados.",
    plans: ["Coach Web", "Performance Web", "Club Start"],
    benefits: ["Calendario semanal", "Trabajo por equipo", "Planificación compartida"],
  },
  "live_tag.use": {
    title: "Live Tag",
    description: "Etiqueta el partido en directo y registra eventos para analizarlos después.",
    plans: ["Coach Suite", "Analyst Suite", "Club Elite"],
    benefits: ["Etiquetado en directo", "Paneles personalizados", "Sesiones sincronizadas"],
  },
  "ai_agent.use": {
    title: "Agente de análisis IA",
    description: "Pregunta sobre tus datos y acelera la preparación de análisis deportivos.",
    plans: ["Coach Suite", "Analyst Suite", "Club Elite"],
    benefits: ["Consultas conversacionales", "Análisis asistido", "Historial de conversaciones"],
  },
  "desktop_client.use": {
    title: "Cliente Windows",
    description: "Trabaja con vídeo y herramientas avanzadas desde la aplicación de escritorio.",
    plans: ["Coach Team", "Analyst Team", "Performance Team", "Club Pro"],
    benefits: ["Flujo de vídeo", "Trabajo de escritorio", "Sincronización con la web"],
  },
};

export const getLicenseFeature = (permission) =>
  LICENSE_FEATURES[permission] || {
    title: "Función incluida con licencia",
    description: "Contrata una licencia compatible para utilizar esta función.",
    plans: [],
    benefits: [],
  };
